export const toCamelCase = (string: string) => {
  const parts = string.split('_');
  return parts
    .map((p, i) => {
      if (i === 0) return p;
      return p[0].toUpperCase() + p.substring(1);
    })
    .join('');
};
